/**
 * Global search service for cross-entity search
 * 
 * @author Claude
 */
import { createApiClient } from './api';

export interface SearchResult {
  id: string;
  type: 'client' | 'report' | 'dimension' | 'proofpoint' | 'criteria' | 'reportdata';
  title: string;
  description: string;
  url: string;
}

export interface GlobalSearchResponse {
  query: string;
  types: string[];
  totalResults: number;
  results: {
    clients?: SearchResult[];
    reports?: SearchResult[];
    dimensions?: SearchResult[];
    proofPoints?: SearchResult[];
    criteria?: SearchResult[];
    reportData?: SearchResult[];
  };
  timestamp: string;
}

export interface SearchSuggestion {
  value: string;
  type: string;
}

export interface SearchSuggestionsResponse {
  query: string;
  suggestions: SearchSuggestion[];
}

/**
 * Perform global search across all entities
 */
export const globalSearch = async (
  token: string,
  query: string,
  types: string[] = ['all'],
  limit = 10
): Promise<GlobalSearchResponse> => {
  const api = createApiClient(token);
  
  const params = new URLSearchParams({
    q: query,
    types: types.join(','),
    limit: limit.toString()
  });
  
  const response = await api.get<GlobalSearchResponse>(`/search?${params.toString()}`);
  return response.data;
};

/**
 * Get search suggestions for autocomplete
 */
export const getSearchSuggestions = async (
  token: string,
  query: string,
  limit = 5
): Promise<SearchSuggestionsResponse> => {
  const api = createApiClient(token);
  
  const params = new URLSearchParams({
    q: query,
    limit: limit.toString()
  });
  
  const response = await api.get<SearchSuggestionsResponse>(`/search/suggestions?${params.toString()}`);
  return response.data;
};

export default {
  globalSearch,
  getSearchSuggestions
};